import {lazy} from 'react';
import {objMap} from './tools/CommonJS';
import {icn} from './tools/UIIcons';
import {ROUTES} from './routePaths.js';
import {validatePatchModuleLicense} from './app/ModuleLicense';

export const defaultPath = ROUTES.MISCON_OVERVIEW;

export const routes = {
	[ROUTES.MISCON_OVERVIEW]: {name: 'Misconfiguration Overview', Comp: lazy(() => import('./pages/MisconOverview'))},
	[ROUTES.MITRE_OVERVIEW]: {name: 'MITRE ATT&CK', Comp: lazy(() => import('./pages/MitreOverview'))},
	[ROUTES.MITRE_OVERVIEW_CATEGORY]: {name: 'Attack Vectors', tName: '$1', Comp: lazy(() => import('./pages/MitreOverview/MitreCategoryPage')), redirect: ROUTES.MITRE_OVERVIEW},
	[ROUTES.MISCON_OVERVIEW_CATEGORY]: {name: 'Misconfiguration Categories', Comp: lazy(() => import('./pages/MisconCategory'))},
	[ROUTES.MISCON_OVERVIEW_TOPIC]: {name: 'Misconfiguration Topic', tName: '$1', Comp: lazy(() => import('./pages/TopicMiscon')), redirect: ROUTES.MISCON_OVERVIEW},
	[ROUTES.ACTION_LOG]: {name: 'Action Center', Comp: lazy(() => import('./pages/ActionLog'))},
	[ROUTES.ACTION_LOG_EXPLORE_ACTION]: {name: 'Explore action', tName: '$1', Comp: lazy(() => import('./pages/ActionExplore')), redirect:ROUTES.ACTION_LOG},
	[ROUTES.AI_SECURITY]: {name: 'AI Governance', Comp: lazy(() => import('./pages/AIGovernance'))},
	[ROUTES.AI_SECURITY_CATEGORY]: {name: 'AI Misconfiguration Categories', tName: 'AI Misconfiguration Category: $1', Comp: lazy(() => import('./pages/AIGovernance/./AIGovernanceCategoryPage')), redirect: ROUTES.AI_SECURITY},
	[ROUTES.AI_SECURITY_TOPIC]: {name: 'AI Security Topic', tName: '$1', Comp: lazy(() => import('./pages/TopicMiscon')), redirect: ROUTES.AI_SECURITY},

	[ROUTES.BENCHMARK_CIS_ISSUES]: {name: 'CIS Security Compliance Standards', Comp: lazy(() => import('./pages/Benchmark'))},
	[ROUTES.BENCHMARK_CIS_ISSUES_MAPPING]: {name: 'CIS Controls Mapped to Other Compliance Systems', Comp: lazy(() => import('./pages/CISMapping'))},
	[ROUTES.BENCHMARK_CIS_ISSUES_TOPIC]: {name: 'CIS Topic', tName: '$1', Comp: lazy(() => import('./pages/TopicBenchmark')), redirect: ROUTES.BENCHMARK_CIS_ISSUES},

	[ROUTES.POLICY_VALIDATION]: {name: 'Policy Validation', Comp: lazy(() => import('./pages/GpoValidator'))},
	[ROUTES.POLICY_VALIDATION_GPO]: {name: 'GPO', tName: '$1', Comp: lazy(() => import('./pages/GpoView'))},
	[ROUTES.ACTIVE_DIRECTORY]: {name: 'Active Directory & Group Policy Objects', Comp: lazy(() => import('./pages/ActiveDirectory'))},
	[ROUTES.ACTIVE_DIRECTORY_IGNORE_LIST]: {name: 'Active Directory Mute Rules', Comp: lazy(() => import('./pages/ADMuteList'))},

	[ROUTES.CUSTOM_POLICY_POLICIES]: {name: 'Manage Policies', Comp: lazy(() => import('./pages/CPolAssignment'))},
	[ROUTES.CUSTOM_POLICY_POLICIES_EDIT_POLICY]: {name: 'Edit Policy', tName: '$1', Comp: lazy(() => import('./pages/CPolEdit')), redirect: ROUTES.CUSTOM_POLICY_POLICIES},
	[ROUTES.CUSTOM_POLICY_POLICY_COMPLIANCE]: {name: 'Policy Compliance', Comp: lazy(() => import('./pages/CPolComplianceRules'))},
	[ROUTES.CUSTOM_POLICY_POLICY_COMPLIANCE_DEVICE]: {name: 'Device Compliance', Comp: lazy(() => import('./pages/CPolComplianceDevices'))},

	[ROUTES.CVE_DASHBOARD]: {name: 'Vulnerability Overview', Comp: lazy(() => import('./pages/VulnOverview'))},
	[ROUTES.CVE_OVERVIEW]: {name: 'Vulnerability Assessment Overview', Comp: lazy(() => import('./pages/CVEOverview'))},
	[ROUTES.CVE_OVERVIEW_TOPIC]: {name: 'Topic CVE', tName: '$1', Comp: lazy(() => import('./pages/TopicCVE')), redirect: ROUTES.CVE_OVERVIEW},

	[ROUTES.ATTACK_SURFACE_DISCOVERY]: {name: 'Discovery', Comp: lazy(() => import('./pages/AttackSurface/AttackSurfaceDiscovery'))},
	[ROUTES.ATTACK_SURFACE_MANAGEMENT]: {name: 'Management', Comp: lazy(() => import('./pages/AttackSurface/AttackSurfaceManagement'))},
	[ROUTES.ATTACK_SURFACE_ACTIVITY]: {name: 'Activity', Comp: lazy(() => import('./pages/AttackSurface/AttackSurfaceActivity'))},
	[ROUTES.ATTACK_SURFACE_TARGET]: {name: 'Target', tName: '$1', Comp: lazy(() => import('./pages/AttackSurface/TargetView')), redirect: ROUTES.ATTACK_SURFACE_DISCOVERY},

	[ROUTES.APP_CONTROL]: {name: 'Application Control', Comp: lazy(() => import('./pages/AppControl'))},
	[ROUTES.APP_CONTROL_OVERVIEW]: {name: 'Application Control Overview', Comp: lazy(() => import('./pages/AppControlOverview/AppControlOverview'))},
	[ROUTES.SYSTEM_AND_DRIVERS]: {name: 'System & Drivers', Comp: lazy(() => import('./pages/AppControl'))},

	[ROUTES.TOPIC_APP_CONTROL]: {tName: '$1', Comp: lazy(() => import('./pages/TopicAppControl')), redirect: ROUTES.APP_CONTROL},
	[ROUTES.TOPIC_SYSTEM_AND_DRIVERS]: {tName: '$1', Comp: lazy(() => import('./pages/TopicAppControl')), redirect: ROUTES.SYSTEM_AND_DRIVERS},

	[ROUTES.PATCH_MANAGEMENT_OS_PATCHES]: {name: 'Patch Management OS Patches', Comp: lazy(() => import('./pages/PatchManagement/PatchManagement'))},
	[ROUTES.PATCH_MANAGEMENT_APP_PATCHES]: {name: 'Patch Management Application Patches', Comp: lazy(() => import('./pages/PatchManagement/PatchManagement'))},
	[ROUTES.PATCH_MANAGEMENT_OVERVIEW]: {name: 'Patch Management Overview', Comp: lazy(() => import('./pages/PatchManagement/PatchManagementOverview'))},
	[ROUTES.PATCH_MANAGEMENT_TOPIC]: {name: 'Patch', tName: '$1', Comp: lazy(() => import('./pages/PatchManagement/TopicPatchManagement')), redirect: ROUTES.PATCH_MANAGEMENT_OS_PATCHES},

	[ROUTES.EXECUTIVE_SUMMARY]: {name: 'Executive Summary', Comp: lazy(() => import('./pages/ExecutiveSummary'))},
	[ROUTES.INTUNE]: {name: 'Microsoft Intune', Comp: lazy(() => import('./pages/Intune'))},

	[ROUTES.DEVICE_GROUPS]: {name: 'Device Groups', Comp: lazy(() => import('./pages/DeviceGroups'))},
	[ROUTES.PERMISSIONS]: {name: 'Permissions', Comp: lazy(() => import('./pages/RolesPermissions'))},
	[ROUTES.INTEGRATIONS]: {name: 'Integrations', Comp: lazy(() => import('./pages/Integrations'))},
	...(import.meta.env.DEV && {
		[ROUTES.DESIGN_SYSTEM]: {name: 'Design System', Comp: lazy(() => import('./v3/pages/DesignSystem'))}
	}),
	[ROUTES.LICENSE]: {name: 'License', Comp: lazy(() => import('./app/UseLicense'))},
	[ROUTES.HEALTH]: {name: 'Health', Comp: lazy(() => import('./pages/Health'))},
	[ROUTES.DEVICES]: {name: 'Devices', Comp: lazy(() => import('./pages/Devices'))},
	[ROUTES.DEVICE_INFO]: {name: 'Device Information', tName: '$1', Comp: lazy(() => import('./pages/DeviceInfo')), redirect:ROUTES.DEVICES},
};

export const notifTypes = {
	clientLog: {h: 'Sensor Logs', sub: 'Purged after 14 days.', action: 'download'},
	offlineExport: {h: 'Exported Data', sub: 'Purged after 14 days.', action: 'download'},
};

export const menu = [
	{h: 'Manage',
		staticMenu: true,
		subMenu: [
			{h: 'Misconfigurations',
				k: ROUTES.MISCON_OVERVIEW,
				icon: 'eye-outline text-lg',
				subMenu: [
					{h: 'MITRE ATT&CK', k: ROUTES.MITRE_OVERVIEW, icon: 'shield', n: 'New'}
				]},
			{h: 'AI Governance', k: ROUTES.AI_SECURITY, icon: icn.autonomous, n: 'New', perms: {module: 'aigovernance'}},
			{h: 'Security Compliance',
				icon: 'shield',
				perms: {module: 'benchmark'},
				subMenu: [
					{h: 'Compliance Mapper', k: ROUTES.BENCHMARK_CIS_ISSUES_MAPPING},
					{h: 'CIS Compliance', k: ROUTES.BENCHMARK_CIS_ISSUES}
				]},
			{h: 'Custom CIS Policies',
				icon: 'customisation scale-150',
				subMenu: [
					{h: 'Manage Policies', k: ROUTES.CUSTOM_POLICY_POLICIES, perms: {module: 'customcis'}},
					{h: 'Policy Compliance', k: ROUTES.CUSTOM_POLICY_POLICY_COMPLIANCE, perms: {module: 'customcis'}}
				]},
			{h: 'Microsoft Policies',
				icon: 'windows',
				subMenu:[
					{h: 'GPO Validation', k: ROUTES.POLICY_VALIDATION, icon: 'lock -ml-0.5 mr-0.5', perms: {module: 'gpovalidation'}},
					{h: 'AD Assessor', k: ROUTES.ACTIVE_DIRECTORY, icon: 'tree', perms: {module: 'adgpo', groupIds: [1002, 1005]}},     // Windows Servers, Windows DC Servers
					{h: 'MS Intune', k: ROUTES.INTUNE, icon: icn.intune, perms: {module: 'intune', envs: ['!onprem', '!demo']}, n: 'Beta'}
				]},
			{h: 'Vulnerabilities',
				icon: 'shield',
				perms: {module: 'vuln_assessment'},
				subMenu: [
					{h: 'Overview', k: ROUTES.CVE_DASHBOARD, icon: 'activity', n: 'New'},
					{h: 'Applications / OS', k: ROUTES.CVE_OVERVIEW, icon: 'applications'}
				]},
			{h: 'Attack Surface',
				icon: 'network-devices',
				n: 'New',
				perms: {module: 'network_scanner'},
				subMenu:[
					{h: 'Discovery', k: ROUTES.ATTACK_SURFACE_DISCOVERY, icon: 'network-devices'},
					{h: 'Management', k: ROUTES.ATTACK_SURFACE_MANAGEMENT, icon: 'control'},
					{h: 'Activity', k: ROUTES.ATTACK_SURFACE_ACTIVITY, icon: 'activity'}
				]},
			{h: 'Application Control',
				icon: 'control',
				perms: {module: 'app_control'},
				subMenu:[
					{h: 'Overview', k: ROUTES.APP_CONTROL_OVERVIEW, icon: 'activity', n: 'New'},
					{h: 'Applications', k: ROUTES.APP_CONTROL, icon: 'applications'},
					{h: 'System & Drivers', k: ROUTES.SYSTEM_AND_DRIVERS, icon: 'system-drivers'}
				]},
			{h: 'Patch Management', k: ROUTES.PATCH_MANAGEMENT_OVERVIEW, icon: 'system-drivers', n: 'New', perms: {module: validatePatchModuleLicense}},
			{h: 'Devices', k: ROUTES.DEVICES, icon: 'devices'},
			{h: 'Action Center', k: ROUTES.ACTION_LOG, icon: 'calendar-check-o'},
			{h: 'Executive Summary', k: ROUTES.EXECUTIVE_SUMMARY, icon: 'briefcase'}
		].filter(Boolean)},
	{h: 'Settings',
		className: 'text-base',
		subMenu: [
			{h: 'System Health', icon: 'health', k: ROUTES.HEALTH, notifs: objMap(notifTypes, (k, v) => v.h)},
			{h: 'Device Groups', icon: 'make-group', k: ROUTES.DEVICE_GROUPS},
			{h: 'Permissions', icon: 'configs', k: ROUTES.PERMISSIONS, perms: {admin: 1}},
			{h: 'Integrations', icon: 'integrations', k: ROUTES.INTEGRATIONS, perms: {admin: 1}},
			{h: 'License', icon: 'liscense text-sm', k: ROUTES.LICENSE, perms: {admin: 1}}
            // { h: "VDI Images", icon: "vdi", k: "/vdi_images", perms: {admin: 1}, a: async () => appCtx.setDlg({Elm: (await import("./pages/VdiImages")).default})},
		]}
];

export const helpActions = [
	{h: 'Can we help?',
		icon: 'room_service',
		className: 'z-20',
		subMenu: [
			{h: 'Welcome tutorial', icon: 'video'},
			{h: 'Expand license', icon: 'cart'},
			{h: 'Missing a feature?', icon: 'screw'},
			{h: 'Report a bug', icon: 'bug'},
			{h: 'Send log', icon: 'report'}
		]}
];
